<template>
    <paper class="deposit">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="currentPage"
            :searchTotalTitle="config.searchTotalTitle"
            searchId="depositQuery"
            pageID="deposit"
            @row-db-click="rowDBclick"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <div slot="table-module-btn"></div>
        </m-pane>
    </paper>
</template>

<script>
import mPane from '@/components/supplierPanel';
import paper from '@/components/core/paper/Paper';
import config from './config.js';
import formatTime from '@/utils/common.js';
import common from '../../../common/common';
import { getDepositLists } from '../../../api/depositApi';
const { initSessionData } = common;
export default {
    name: 'depositIndex',
    components: { mPane, paper },
    data() {
        return {
            selected: [],
            searchDataLists: {},
            currentPage: 1,
            selectData: [],
            searchObj: {
                pageNo: 1,
                pageSize: 10
            },
            pageTotal: 0,
            totalData: [],
            loading: false,
            config
        };
    },
    mounted() {
        initSessionData(['BID_BUSINESS_TYPE', 'SYS_BMS_DEPOSIT_PAY_TYPE', 'SYS_BMS_DEPOSIT_AP_STATUS', 'SRM_BMS_SUP_DEPOSIT_TYPE']);
        if (this.$route.query.from === 'todoList') {
            this.handleTodo();
        } else {
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        }
    },
    activated() {
        // 根据路由参数判断不同页面，修改埋点参数
        if (this.$route.query.nav && this.$route.query.nav === 'contract') {
            window.bigDataConfig = { 'bigData-btn-search': '合同管理,押金管理,,押金管理-查询' };
        }
        // 首页跳转过来 参数处理
        if (this.$route.query.from === 'todoList') {
            this.handleTodo();
        }
    },
    methods: {
        // 首页跳转过来 参数处理
        handleTodo() {
            this.$set(this.searchDataLists, 'supCashNo', this.$route.query.supCashNo || '');
            this.$set(this.searchDataLists, 'statues', '20,30');
            this.$set(this.searchDataLists, 'suppliersCashType', '1');
            this.$refs.tablePage.$refs.searchList.setQueryParams({ ...this.searchDataLists, supCashNo: this.$route.query.supCashNo, statues: ['20', '30'] || '', suppliersCashType: '1' });
            this.$router.replace({ query: {} });
            this.load();
        },
        load() {
            this.$refs.tablePage.$refs.searchList.changeLoading(true);
            this.loading = true;
            const params = { pageNo: this.searchObj.pageNo, pageSize: this.searchObj.pageSize, ...this.searchDataLists };
            this.currentPage = this.searchObj.pageNo;
            getDepositLists(params).then(res => {
                if (res && res.code === '0') {
                    const { SRM_BMS_SUP_DEPOSIT_STATUS, BID_BUSINESS_TYPE } = window.sessionStorage;
                    this.totalData = res.data.list.map(item => {
                        // item.suppliersCashType = SRM_BMS_SUP_DEPOSIT_TYPE ? JSON.parse(SRM_BMS_SUP_DEPOSIT_TYPE)[item.suppliersCashType]
                        //     : item.suppliersCashType;
                        item.status = SRM_BMS_SUP_DEPOSIT_STATUS ? JSON.parse(SRM_BMS_SUP_DEPOSIT_STATUS)[item.status] : item.status;
                        item.businessProperty = BID_BUSINESS_TYPE ? JSON.parse(BID_BUSINESS_TYPE)[item.businessProperty] : item.businessProperty;
                        return item;
                    });
                    this.pageTotal = res.data.totalCount;
                }
                this.$refs.tablePage.$refs.searchList.changeLoading(false);
                this.loading = false;
            }).catch(() => {
                this.$refs.tablePage.$refs.searchList.changeLoading(false);
                this.loading = false;
            });
        },
        pageChange(data) {
            this.searchObj.pageNo = data;
            this.load(this.searchDataLists);
        },
        sizeChange(data) {
            this.currentPage = 1;
            this.searchObj.pageSize = data;
            this.searchObj.pageNo = 1;
            this.load(this.searchDataLists);
        },
        searchChange(data) {
            data['suppliersCashType'] = '1';
            data.statues && (data.statues = data.statues.join());
            this.searchObj.pageNo = 1;
            data = this.formattingData(data);
            this.searchDataLists = data;
            this.load();
        },
        formattingData(data) {
            const tempData = {
                createTimeBegin: data.createTime ? formatTime.formatDate(data.createTime[0]) + ' 00:00:00' : '',
                createTimeEnd: data.createTime ? formatTime.formatDate(data.createTime[1]) + ' 23:59:59' : '',
                ...data
            };
            delete tempData.createTime;
            return tempData;
        },
        rowDBclick(row) {
            if (row.supCashNo) {
                this.$router.push({
                    query: { supCashNo: row.supCashNo },
                    path: `/bms/depositDetails`
                });
            } else {
                return this.$message.warning('没有对应的押金单据编号，不允许查询数据详情');
            }
        },
        selectChange(data) {
            data.forEach(item => {
                this.supCashNo = item.supCashNo;
            });
            this.selected = [].concat(data);
        }
    }
};
</script>

<style lang="less">

</style>
